import { Apiv3GetRequest } from '../api-v3';

export const state = {
  data: {
    detail: false,
    loading: false,
    items_in: false,
    items_out: false,
    search_in: '',
    search_out: '',
  },
};

export const mutations = {
  changePrintEir(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getEirIn({ commit }, payload = null) {
    commit('changePrintEir', {
      loading: true,
      items_in: false,
    });

    let result = await Apiv3GetRequest(`eir-in`, payload);
    commit('changePrintEir', {
      items_in: !result.error ? result.data.object : false,
      loading: false,
    });

    return !result.error ? result.data.object : false;
  },

  async getDetailEirIn({ commit }, payload = null) {
    commit('changePrintEir', {
      loading: true,
      items_in: false,
    });

    let result = await Apiv3GetRequest(`eir-in/${payload.id}`);
    if (!result.error) {
      commit('changePrintEir', {
        ...result.data.object,
        loading: false,
      });
    } else {
      commit('changePrintEir', {
        loading: false,
      });
    }

    return !result.error ? true : false;
  },

  async getEirOut({ commit }, payload = null) {
    commit('changePrintEir', {
      loading: true,
      items_out: false,
    });

    let result = await Apiv3GetRequest(`eir-out`, payload);
    commit('changePrintEir', {
      items_out: !result.error ? result.data.object : false,
      loading: false,
    });

    return !result.error ? result.data.object : false;
  },

  async getDetailEirOut({ commit }, payload = null) {
    commit('changePrintEir', {
      loading: true,
      items_out: false,
    });

    let result = await Apiv3GetRequest(`eir-out/${payload.id}`);
    if (!result.error) {
      commit('changePrintEir', {
        ...result.data.object,
        loading: false,
      });
    } else {
      commit('changePrintEir', {
        loading: false,
      });
    }

    return !result.error ? true : false;
  },
};
